import { CookieAlertOutlineIcon } from './CookieAlertOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 927FC7C7-8DF3-47FE-BAC4-7DF8DAF3F936
 * name cookie-alert-outline
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cookie-alert-outline.svg
 * tags
 * - Food / Drink 
 * - Alert / Error 
 */
export const BiscuitAlertOutlineIcon = CookieAlertOutlineIcon;
export default BiscuitAlertOutlineIcon